import { InterpolationType } from '../enums/interpolation-type';
import { CartesianPoint } from './cartesian-point';
import { CurveCartesian } from './curve-cartesian';
import { CurvePolar } from './curve-polar';
import { PolarPoint } from './polar-point';

export interface PlotData {
  plotActivated: boolean;
  curve: (CurveCartesian | CurvePolar)[];
  curveNames: string[];
  xLabel: string;
  yLabel: string;
  notablePoints: (CartesianPoint | PolarPoint)[];
  notablePointsNames: string[];
  interpolationType?: InterpolationType;
  boundsByNotablePoints?: boolean;
  scaleType?: ScaleType;
}

export enum ScaleType {
  LINEAR_SCALE = 'LINEAR_SCALE',
  LOG_SCALE = 'LOG_SCALE',
}
